import { testimonials } from "@/mocks/home";

function Brand() {
  return (
    <section id="brand" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
              <i className="ri-vip-diamond-line"></i>
              品牌介绍
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              让每一页阅读，都有温度
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              哔咔漫画始终相信，好的阅读体验藏在细节里。翻页音效与翻页动画正是我们为纸感阅读
              打磨的核心能力——从真实拾音的纸页摩擦声，到 GPU 加速的丝滑翻页动画，
              我们希望还原翻开一本实体漫画时的那份亲切与沉浸。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              无论是深夜被窝里的恋爱漫，还是通勤路上的热血追更，哔咔漫画都让声音与画面
              默契配合，陪伴每一位漫迷沉浸在自己喜欢的故事里。
            </p>

            <div className="mt-6 grid grid-cols-3 gap-3">
              {[
                { icon: "ri-heart-3-line", num: "98%", label: "用户好评率" },
                { icon: "ri-flashlight-line", num: "60fps", label: "翻页流畅度" },
                { icon: "ri-book-2-line", num: "12万+", label: "在更漫画" },
              ].map((s) => (
                <div key={s.label} className="rounded-xl border border-background-200 bg-background-50 p-4 text-center">
                  <i className={`${s.icon} text-xl text-accent-600`}></i>
                  <p className="mt-2 text-xl font-bold text-foreground-950">{s.num}</p>
                  <p className="text-xs text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-2xl text-foreground-950 md:text-3xl">用户口碑</h3>
            <div className="mt-5 space-y-4">
              {testimonials.map((t) => (
                <figure
                  key={t.id}
                  className="rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-200"
                >
                  <div className="flex items-center gap-3">
                    <img
                      src={t.avatar}
                      alt={`${t.name}的头像`}
                      className="h-11 w-11 rounded-full object-cover"
                    />
                    <figcaption>
                      <span className="block font-medium text-foreground-950">{t.name}</span>
                      <span className="text-xs text-foreground-500">{t.role}</span>
                    </figcaption>
                    <span className="ml-auto flex items-center gap-1 text-accent-500">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                    </span>
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                    “{t.text}”
                  </blockquote>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Brand;